const composeToTenDigits = (parameter) => {
    let string = parameter.toString();
    if (string.length < 2) string = `0${string}`;
    return string;
};

const getLastWeek = () => {
    const lastWeek = [];
    const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const today = new Date().getTime();
    for (let i = 1; i < 8; i += 1) {
        const time = new Date(today - (86400000 * i));
        const month = composeToTenDigits(time.getMonth() + 1);
        const date = composeToTenDigits(time.getDate());
        const day = time.getDay();
        lastWeek.push({ month, date, day: weekday[day] });
    }
    return { lastWeek: lastWeek.reverse() };
};

export default getLastWeek;
